/* CasaRosa load-more pagination (Phase 5 revision)
   Replaces Dawn's numbered pagination with a single 'Load more' button
   that fetches the next paginate.next.url via section_id and appends
   new .grid__item entries to the current #product-grid.
*/
(function () {
  if (window.__casarosaLoadMoreInit) return;
  window.__casarosaLoadMoreInit = true;

  function loadMore(btn) {
    var url = btn.getAttribute('data-next-url');
    if (!url || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newItems = tmp.querySelectorAll('#product-grid .grid__item');
        var currentGrid = document.querySelector('#product-grid');

        if (currentGrid && newItems.length > 0) {
          for (var i = 0; i < newItems.length; i++) {
            currentGrid.appendChild(newItems[i]);
          }
        }

        var newBtn = tmp.querySelector('[data-cr-load-more]');
        if (newBtn) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          var newCount = tmp.querySelector('.cr-load-more__count');
          var currentCount = document.querySelector('.cr-load-more__count');
          if (newCount && currentCount) {
            currentCount.textContent = newCount.textContent;
          }
        } else {
          var wrap = document.querySelector('.cr-load-more-wrap');
          if (wrap) wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function (err) {
        console.error('[casarosa-load-more] failed:', err);
      })
      .then(function () {
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cr-load-more]');
    if (!btn) return;
    e.preventDefault();
    loadMore(btn);
  });
})();
